module.exports = __webpack_public_path__ + "media/images/top/reserved_bg-eab63574f5d8237dbaf212212b8ea691.gif";